<template>
  <div class="widget Anim__dropdown-wrapper">
    <div class="widget__hdr">
      <span class="widget__hdr-text">осталось</span>
      <span class="widget__days">
        {{ daysLeft }} <span class="widget__days-prefix">{{ time }}</span>
      </span>
    </div>
    <div class="widget__content">
      <div class="widget__content-hdr">
        <StarsIcon /> В подписке
      </div>
      <ul class="widget__list">
        <li class="widget__content-item">
          <div class="widget__item-icon">
            <DropsIcon />
          </div>
          <span class="widget__text">Полный доступ к Drops Capital</span>
        </li>
        <li class="widget__content-item-column">
          <div class="widget__content-group" @click="isOpenWorkChatGroup = !isOpenWorkChatGroup">
            <div class="widget__content-group-item">
              <div class="widget__item-icon">
                <AvatarImage :src="PON_IMAGE" :size="18" />
              </div>
              <span class="widget__text">Кэпитал Work чат</span>
            </div>
            <ArrowIcon class="widget__arrow" :class="isOpenWorkChatGroup ? 'widget__arrow--rotate' : ''" v-if="!isAlwaysOpened"/>
          </div>
          <hr class="widget__separator" v-if="isOpenWorkChatGroup || isAlwaysOpened" />
          <div class="widget__content-group-block" v-if="isOpenWorkChatGroup || isAlwaysOpened">
            <div class="widget__item-icon">
              <AvatarImage :src="STAR_IMAGE" :size="18" />
            </div>
            <span class="widget__text">Чтобы присоединиться к чату, нажмите “Открыть группу” в 
              <a class="widget__link" href="https://t.me/tribute">Tribute-боте</a>
            </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { computed, ref } from 'vue';
  import { Props } from './props';
  //-------------------------
  import StarsIcon from './icons/StarsIcon.vue';
  import DropsIcon from './icons/DropsIcon.vue';
  import AvatarImage from '@shared/UI/Images/AvatarImage/AvatarImage.vue';
  import ArrowIcon from './icons/ArrowIcon.vue';
  //-------------------------
  const store = useStore();
  const props = defineProps(Props());
  //-------------------------
  const isOpenWorkChatGroup = ref(false);
  //-------------------------
  const PON_IMAGE = require('./icons/pon.jpg');
  const STAR_IMAGE = require('./icons/star.png');
  //-------------------------
  const declOfNum = (n, textForms) => {
    n = Math.abs(n) % 100;
    let n1 = n % 10;
    if (n > 10 && n < 20) return textForms[2];
    if (n1 > 1 && n1 < 5) return textForms[1];
    if (n1 === 1) return textForms[0];
    return textForms[2];
  }

  const subscriptionEndDate = computed(() => store.state.UserSystem.user.telegram_subscription_end_date);

  const daysLeft = computed(() => {
    if (!subscriptionEndDate.value) return 0;

    const now = new Date();
    const endDate = new Date(subscriptionEndDate.value);
    const diff = endDate - now;

    return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
  });

  const time = computed(() => {
    const num = daysLeft.value;
    const word = declOfNum(num, ['день', 'дня', 'дней']);
    return `${word}`;
  });
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>